import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAxiosInstance } from "../../../api";

const initialState = {
  menuDrawer: {},
  showEditModal: false,
  tableFields: {},
  dashboard_permissions: {},
  dashboard_permissions_status: "idle",
};

export const getMenuPermissions = createAsyncThunk(
  "global/getMenuPermissions",
  async (body, { rejectWithValue }) => {
    const api = await getAxiosInstance();
    try {
      const response = await api.get(`v1/menu`);

      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getProfilePermissions = createAsyncThunk(
  "global/getProfilePermissions",
  async (_, { rejectWithValue }) => {
    const api = await getAxiosInstance();
    try {
      const response = await api.get(`admin/members/profile/menu`);

      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const globalSlice = createSlice({
  name: "role",
  initialState,
  reducers: {
    updateConfig: (state, action) => {
      action.payload(state);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getMenuPermissions.pending, (state) => {
      state.dashboard_permissions_status = "pending";
    });
    builder.addCase(getMenuPermissions.fulfilled, (state, action) => {
      state.dashboard_permissions = action.payload.data.data;
      state.dashboard_permissions_status = "fulfilled";
      localStorage.setItem(
        "dashboard_permissions",
        JSON.stringify(action.payload.data.data)
      );
    });
    builder.addCase(getMenuPermissions.rejected, (state) => {
      state.dashboard_permissions_status = "rejected";
    });
    builder.addCase(getProfilePermissions.pending, (state) => {
      state.profile_permissions_status = "pending";
    });
    builder.addCase(getProfilePermissions.fulfilled, (state, action) => {
      state.profile_permissions = action.payload.data.data;
      state.profile_permissions_status = "fulfilled";
      localStorage.setItem(
        "profile_permissions",
        JSON.stringify(action.payload.data.data)
      );
    });
    builder.addCase(getProfilePermissions.rejected, (state) => {
      state.profile_permissions_status = "rejected";
    });
  },
});

export const { updateConfig } = globalSlice.actions;

export default globalSlice.reducer;
